import { render, staticRenderFns } from "./CardRatings.vue?vue&type=template&id=1a14e84a&"
import script from "./CardRatings.vue?vue&type=script&lang=js&"
export * from "./CardRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports